import { shape, string } from "prop-types"

export const ProposalShape = shape({
    proposalId: string.isRequired,
    name: string.isRequired,
    code: string
})